import {
  Button,
  CreateButton,
  EditButton,
  Icons,
  List,
  Popconfirm,
  ShowButton,
  Space,
  Table,
  TableProps,
  Tag,
  notification,
} from '@pankod/refine-antd';
import CustomTableWithPagination from 'components/table/custom-table';
import { useEffect, useState } from 'react';
import { ITemplate, deleteTemplate, getTemplates } from 'services/template';
import MetaData from 'utilities/metadata';
import { capitalize } from 'utilities/shared';

export const TemplateList: React.FC = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [templates, setTemplates] = useState<ITemplate[]>([]);
  const [page, setPage] = useState<number>(1);
  const [limit, setLimit] = useState<number>(10);

  const fetchData = async () => {
    try {
      setIsLoading(true);
      const data = await getTemplates();
      setTemplates(data);
    } catch (err: any) {
      console.error(err.message);
      notification.error({
        message: 'Failed',
        description: err.message,
      });
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const pageHeaders = (
    <Space>
      <CreateButton type="primary" />
    </Space>
  );

  const onTableChange: TableProps<any>['onChange'] = async (
    pagination,
    filters,
    _sorter,
    _extra
  ) => {
    const page = pagination.current ?? 1;
    const limit = pagination.pageSize ?? 10;
    setPage(page);
    setLimit(limit);
  };

  const onPageChange: any = async (page: number, pageSize: number) => {
    setPage(page);
    setLimit(pageSize);
  };

  return (
    <List headerProps={{ extra: pageHeaders }}>
      <MetaData />
      <CustomTableWithPagination
        total={templates.length || 0}
        page={page}
        limit={limit}
        onPageChange={onPageChange}
      >
        <Table
          dataSource={templates}
          loading={isLoading}
          rowKey="id"
          scroll={{ x: true }}
          onChange={onTableChange}
          pagination={false}
        >
          <Table.Column dataIndex="name" title="Name" />
          <Table.Column<ITemplate>
            dataIndex="productAttribute"
            title="Attributes"
            render={(_, record): React.ReactNode => {
              const attributes = record.productAttribute;
              return attributes.map((attribute) => (
                <Tag style={{ margin: 2 }} key={attribute.id}>
                  {capitalize(attribute.name)}
                </Tag>
              ));
            }}
          />
          <Table.Column<ITemplate>
            title="Actions"
            dataIndex="actions"
            render={(_, record): React.ReactNode => {
              return (
                <Space>
                  <ShowButton size="small" recordItemId={record.id} hideText />
                  <EditButton size="small" recordItemId={record.id} hideText />
                  <Popconfirm
                    title="Are you sure?"
                    okText="Delete"
                    onConfirm={async () => {
                      await deleteTemplate(record.id);
                      await fetchData();
                    }}
                  >
                    <Button size="small" danger icon={<Icons.DeleteOutlined />} />
                  </Popconfirm>
                </Space>
              );
            }}
          />
        </Table>
      </CustomTableWithPagination>
    </List>
  );
};
